<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form">
      <a-form-model-item label="订单id" prop="orderNo" >
        <a-input v-model="form.id" disabled/>
      </a-form-model-item>
      <a-form-model-item label="订单类型" prop="type">
        <a-select v-model="form.type" disabled>
          <a-select-option :value="1">兑换商城</a-select-option>
          <a-select-option :value="2">闲橙优选</a-select-option>
          <a-select-option :value="3">闲橙健康</a-select-option>
          <a-select-option :value="4">课程订单</a-select-option>
          <a-select-option :value="5">会员商品</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-select v-model="form.status" disabled>
          <a-select-option :value="0">待支付</a-select-option>
          <a-select-option :value="1">已支付</a-select-option>
          <a-select-option :value="2">已发货</a-select-option>
          <a-select-option :value="3">已完成</a-select-option>
          <a-select-option :value="4">已售后</a-select-option>
          <a-select-option :value="-1">已取消</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="总金额" prop="totalAmount" >
        <a-input v-model="form.totalAmount" placeholder="请输入总金额" disabled/>
      </a-form-model-item>
      <a-form-model-item label="优惠金额" prop="discountAmount" >
        <a-input v-model="form.discountAmount" placeholder="请输入优惠金额" disabled/>
      </a-form-model-item>
      <a-form-model-item label="用户名称" prop="nickname" >
        <a-input v-model="form.nickname" placeholder="请输入用户名称" disabled/>
      </a-form-model-item>
      <a-form-model-item label="支付金额" prop="payAmount" >
        <a-input v-model="form.payAmount" placeholder="请输入支付金额" disabled/>
      </a-form-model-item>
      <a-form-model-item label="消耗积分数" prop="reduceScores" >
        <a-input v-model="form.reduceScores" placeholder="请输入消耗积分数" disabled/>
      </a-form-model-item>
      <a-form-model-item label="消耗现金券额度" prop="reduceVoucher" >
        <a-input v-model="form.reduceVoucher" placeholder="请输入消耗现金券额度" disabled/>
      </a-form-model-item>
      <a-form-model-item label="运费" prop="freightAmount" >
        <a-input v-model="form.freightAmount" placeholder="请输入运费" disabled/>
      </a-form-model-item>
      <a-form-model-item label="支付金额" prop="payAmount" >
        <a-input v-model="form.payAmount" placeholder="请输入支付金额" disabled/>
      </a-form-model-item>
      <a-form-model-item label="支付方式" prop="payType" >
        <a-select v-model="form.payType" disabled>
          <a-select-option :value="1">微信</a-select-option>
          <a-select-option :value="2">支付宝</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="支付时间" prop="payTime" >
        <a-input v-model="form.payTime" placeholder="请输入支付时间" disabled/>
      </a-form-model-item>
      <a-form-model-item label="插入时间" prop="createTime" >
        <a-input v-model="form.createTime" placeholder="请输入插入时间" disabled/>
      </a-form-model-item>
      <a-form-model-item label="分销金额" prop="distributionAmount" >
        <a-input v-model="form.distributionAmount" placeholder="请输入分销金额" disabled/>
      </a-form-model-item>
      <a-form-model-item label="地址" prop="address" >
        <a-input v-model="form.address" placeholder="请输入地址" disabled/>
      </a-form-model-item>

<!--      <a-form-model-item label="税费" prop="taxesAmount" >
        <a-input v-model="form.taxesAmount" placeholder="请输入税费" />
      </a-form-model-item>
      <a-form-model-item label="上级用户id" prop="distributorUserId" >
        <a-input v-model="form.distributorUserId" placeholder="请输入上级用户id" />
      </a-form-model-item>
      <a-form-model-item label="支付类型 1-paypal" prop="payType" >
      </a-form-model-item>
      <a-form-model-item label="支付时间" prop="payTime" >
        <a-date-picker style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="收货地址" prop="addressId" >
        <a-input v-model="form.addressId" placeholder="请输入收货地址" />
      </a-form-model-item>
      <a-form-model-item label="收货人姓名" prop="reciverName" >
        <a-input v-model="form.reciverName" placeholder="请输入收货人姓名" />
      </a-form-model-item>
      <a-form-model-item label="性别,0-保密 1-男 2-女" prop="sex" >
      </a-form-model-item>
      <a-form-model-item label="收货人手机号" prop="reciverTelephone" >
        <a-input v-model="form.reciverTelephone" placeholder="请输入收货人手机号" />
      </a-form-model-item>
      <a-form-model-item label="标签(如：公司 ,家,学校 等等)" prop="addressLabel" >
        <a-input v-model="form.addressLabel" placeholder="请输入标签(如：公司 ,家,学校 等等)" />
      </a-form-model-item>
      <a-form-model-item label="国家" prop="country" >
        <a-input v-model="form.country" placeholder="请输入国家" />
      </a-form-model-item>
      <a-form-model-item label="省份" prop="areap" >
        <a-input v-model="form.areap" placeholder="请输入省份" />
      </a-form-model-item>
      <a-form-model-item label="城市" prop="areac" >
        <a-input v-model="form.areac" placeholder="请输入城市" />
      </a-form-model-item>
      <a-form-model-item label="县" prop="areax" >
        <a-input v-model="form.areax" placeholder="请输入县" />
      </a-form-model-item>
      <a-form-model-item label="详细地址" prop="detailedAddress" >
        <a-input v-model="form.detailedAddress" placeholder="请输入详细地址" />
      </a-form-model-item>
      <a-form-model-item label="邮政编码" prop="zipCode" >
        <a-input v-model="form.zipCode" placeholder="请输入邮政编码" />
      </a-form-model-item>
      <a-form-model-item label="是否提醒发货" prop="isWarn" >
        <a-input v-model="form.isWarn" placeholder="请输入是否提醒发货" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
<!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>-->
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOrder, addOrder, updateOrder } from '@/api/order/order'

export default {
  name: 'InfoForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        orderNo: null,

        outTrandNo: null,

        userId: null,

        status: 0,

        refundStatus: 0,

        quantity: null,

        totalAmount: null,

        payAmount: null,

        reduceScores: null,

        reduceVoucher:null,

        freightAmount: null,

        taxesAmount: null,

        discountAmount: null,

        distributorUserId: null,

        payType: null,

        payTime: null,

        addressId: null,

        reciverName: null,

        sex: null,

        distributionAmount: null,

        reciverTelephone: null,

        addressLabel: null,

        country: null,

        areap: null,

        areac: null,

        areax: null,

        detailedAddress: null,

        zipCode: null,

        isWarn: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      /*rules: {
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '商品总数不能为空', trigger: 'blur' }
        ],
        totalAmount: [
          { required: true, message: '总金额不能为空', trigger: 'blur' }
        ],
        payAmount: [
          { required: true, message: '支付金额不能为空', trigger: 'blur' }
        ],
        freightAmount: [
          { required: true, message: '运费不能为空', trigger: 'blur' }
        ],
        taxesAmount: [
          { required: true, message: '税费不能为空', trigger: 'blur' }
        ],
        addressId: [
          { required: true, message: '收货地址不能为空', trigger: 'blur' }
        ]
      }*/
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        orderNo: null,
        outTrandNo: null,
        userId: null,
        status: 0,
        refundStatus: 0,
        quantity: null,
        totalAmount: null,
        payAmount: null,
        reduceScores:null,
        reduceVoucher:null,
        freightAmount: null,
        taxesAmount: null,
        discountAmount: null,
        distributorUserId: null,
        payType: null,
        payTime: null,
        addressId: null,
        reciverName: null,
        sex: null,
        distributionAmount:null,
        reciverTelephone: null,
        addressLabel: null,
        country: null,
        areap: null,
        areac: null,
        areax: null,
        detailedAddress: null,
        zipCode: null,
        isWarn: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrder({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOrder(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOrder(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
